import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitizes a string for use in a filename.
 * Strips newlines, collapses whitespace, removes filesystem-unsafe characters,
 * and trims leading/trailing whitespace and dots.
 */
export function sanitizeFilename(name: string): string {
  return name
    .replace(/[\r\n]+/g, " ")       // replace newlines with space
    .replace(/\s+/g, "_")           // collapse whitespace to underscore
    .replace(/[<>:"/\\|?*]/g, "")   // remove filesystem-unsafe chars
    .replace(/^[.\s_]+|[.\s_]+$/g, "") // trim leading/trailing dots, spaces, underscores
}

